<template>
  <component :is="layoutComponent">
    <div class="sidebar-enabled">
      <div class="container-fluid">
        <div class="row">
          <!-- Sidebar-->
          <div v-if="showSidebar" class="sidebar col-lg-3 px-0">
            <div id="blog-sidebar" class="offcanvas offcanvas-collapse bg-gray" style="visibility: hidden;">
              <div class="offcanvas-header navbar-shadow px-4">
                <h5 class="mt-1 mb-0">{{ title ?? $t('index.filters') }}</h5>
                <button id="close" data-test="close" type="button" data-bs-dismiss="offcanvas" :aria-label="this.$t('Nav.close')" class="btn-close lead"></button>
              </div>
              <div class="offcanvas-body pt-lg-0 ps-lg-0 pe-lg-2 pe-xl-4" data-simplebar="init" :style="{'padding': adminSidebar ? '1.25rem 0 !important' : '1.25rem 1.5rem 1.25rem 0.5rem !important'}">
                <div class="simplebar-wrapper" style="margin: 0px -24px 0px 0px;">
                  <div class="simplebar-height-auto-observer-wrapper"><div class="simplebar-height-auto-observer"></div></div>
                  <div class="simplebar-mask">
                    <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                      <div class="simplebar-content-wrapper" style="height: auto;">
                        <slot name="sidebar"></slot>
                      </div>
                    </div>
                  </div>
                  <div class="simplebar-placeholder" style="width: auto;"></div>
                </div>
                <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                  <div class="simplebar-scrollbar" style="width: 0px; display: none"></div>
                </div>
                <div class="simplebar-track simplebar-vertical" style="visibility: hidden;">
                  <div class="simplebar-scrollbar" style="height: 0px; display: none; transform: translate3d(0px, 0px, 0px);"></div>
                </div>
              </div>
            </div>
          </div>
          <div :class="showSidebar ? 'col-lg-9 px-0 py-4' : 'col-lg-12 py-0 ps-0'" class="content mb-2 mb-sm-0 pb-sm-5">
            <slot></slot>
          </div>
        </div><br />
        <button
          v-if="showSidebar"
          id="filters"
          data-test="filters"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#blog-sidebar"
          class="btn btn-primary btn-sm sidebar-toggle-btn border-0 rounded-0 py-2 pb-1 d-lg-none px-1"
        >
          <i class="ai-sidebar fs-base me-2"></i>
          {{ title ?? $t('index.filters') }}
        </button>
      </div>
    </div>
  </component>
</template>
<script>
import DefaultLayout from '@/views/layouts/default';

export default {
  name: 'DefaultSidebarLayout',
  components: {
    DefaultLayout,
  },
  props: {
    showSidebar: {
      type: Boolean,
      default: true,
    },
    adminSidebar: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    layoutComponent() {
      if (this.$route.name == 'courses') {
        return 'NoLayout';
      }
      return 'DefaultLayout';
    },
  },

};
</script>
<style scoped>
.sidebar-toggle-btn {
  width: 10rem;
  position: fixed !important;
  top: 40%;
  left: 0px;
  border-top-left-radius: 100px !important;
  border-top-right-radius: 100px !important;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform-origin: bottom left;
}
.sidebar-enabled::before {
  background-color: unset;
}
.container-fluid {
  padding-right: 0;
  padding-left: 0;
}
.sidebar-enabled .content {
  padding-left: 15px;
}
@media (min-width: 992px){
  .sidebar {
    z-index: 2 !important;
  }
}
</style>